import { render, staticRenderFns } from "./detail_tab_tsf.vue?vue&type=template&id=4bec6dfa&scoped=true"
import script from "./detail_tab_tsf.vue?vue&type=script&lang=js"
export * from "./detail_tab_tsf.vue?vue&type=script&lang=js"
import style0 from "./detail_tab_tsf.vue?vue&type=style&index=0&id=4bec6dfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bec6dfa",
  null
  
)

export default component.exports